import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import ProjectClient from 'rest/ProjectClient';
import { errorAction } from 'components/utility/actions';
import * as actions from './actions';

const projectClient = new ProjectClient();

export function doFetchProject() {
	return projectClient.get();
}

export function *fetchProject(action) {
	try {
		const response = yield call(doFetchProject);
		yield put({ type: actions.FETCH_PROJECT_SUCCESS, payload: response.data });
	} catch (error) {
		yield put(errorAction(actions.FETCH_PROJECT_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.FETCH_PROJECT, fetchProject);
}
